export type Testimonial = {
  name: string
  role: string
  photo: string
  quote: string
  stars: number
}

export const HERO_TESTIMONIALS: Testimonial[] = [
  {
    name: 'Martín G.',
    role: 'Administrativo, Rosario',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/a66e7caa-57fc-4f11-bd73-e3ebe770a976.jpg',
    quote:
      'No es solo teoría. Son cosas concretas que aplico el mismo día, entre reunión y reunión, sin cambiarme de ropa.',
    stars: 5,
  },
  {
    name: 'Carolina P.',
    role: 'Contadora, CABA',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/7755e019-e08e-4b28-abaa-cf2df718e1d5.jpg',
    quote:
      'Es práctico. No es otro PDF que se baja y junta polvo en el celular: lo abro, hago lo que dice y listo.',
    stars: 5,
  },
  {
    name: 'Diego R.',
    role: 'Jefe de depósito, Córdoba',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/9fcc7d45-98ba-44e4-8fa2-4ac1c3e5b698.jpg',
    quote:
      'Me hizo entender que no era falta de voluntad. Era falta de sistema. Eso solo ya me cambió la semana.',
    stars: 5,
  },
]

export const MORE_TESTIMONIALS: Testimonial[] = [
  {
    name: 'Sofía L.',
    role: 'Atención al cliente, La Plata',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/149625c8-7300-4aea-bf6d-c2dcc1ec0eaf.jpg',
    quote:
      'Llegaba a las 4 de la tarde muerta y con el tercer café. Cambié dos cosas del Tomo 2 y esa bajada casi no la siento más.',
    stars: 5,
  },
  {
    name: 'Nicolás F.',
    role: 'Desarrollador, Mendoza',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/8c6babd1-a7c7-4767-8a80-dc98e8c64e2d.jpg',
    quote:
      'Odio el gimnasio y no pienso ir. Las rutinas de 5 minutos las hago al lado del escritorio y no me cuestan nada.',
    stars: 5,
  },
  {
    name: 'Valeria M.',
    role: 'Docente, Mar del Plata',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/af10d447-d009-4315-bf2e-1b3a8b09fb0e.jpg',
    quote:
      'El planificador imprimible lo tengo pegado en la heladera. Verlo tildado me sostiene más que cualquier motivación.',
    stars: 5,
  },
  {
    name: 'Jorge A.',
    role: 'Vendedor, Salta',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/86e18c27-e341-4b06-8c07-afe038f4baaf.jpg',
    quote:
      'Tengo 54 y probé de todo. Lo bueno de esto es que no te pide que cambies la vida entera: te pide tres cosas por semana.',
    stars: 5,
  },
]

export const PAIN_POINTS: string[] = [
  'Arrastrarte hasta la oficina el lunes con el café como único plan',
  'El bajón de las 4 de la tarde en medio de una reunión, disimulando que te estás por dormir',
  'Salir del trabajo sin energía para nada que no sea el sillón',
  'Empezar el gimnasio en enero y dejarlo antes de marzo, otra vez',
  'Pasar el fin de semana "recuperándote" de una semana en la que no hiciste nada físico',
  'Prometerte cada domingo a la noche que esta semana sí vas a moverte',
]

export type Tomo = {
  number: string
  title: string
  subtitle: string
  description: string
  deliverable: string
}

export const TOMOS: Tomo[] = [
  {
    number: '01',
    title: 'Por qué vivís cansado',
    subtitle: 'El diagnóstico',
    description:
      'Una autoevaluación guiada para identificar la causa real de tu cansancio, en vez de seguir atacando síntomas al azar.',
    deliverable: '8 ejercicios de autodiagnóstico + guía de mentalidad',
  },
  {
    number: '02',
    title: 'Tu energía se come en la cocina',
    subtitle: 'Comida y energía',
    description:
      'Los hábitos alimentarios que te drenan la energía, qué comer y qué evitar. Sin dieta restrictiva ni pesar comida.',
    deliverable: 'Guía práctica + recetario rápido de energía',
  },
  {
    number: '03',
    title: 'Movete sin pisar un gimnasio',
    subtitle: 'Movimiento real',
    description:
      'Una rutina de movimiento simple, integrada a tu día de trabajo, sin equipo, sin ropa deportiva y sin viajes al gimnasio.',
    deliverable: 'Rutinas de 5, 15 y 30 minutos, sin gimnasio',
  },
  {
    number: '04',
    title: 'Rutina y descanso que sostienen la energía',
    subtitle: 'El sostén',
    description:
      'Hábitos de sueño y orden del día para que los cambios no duren dos semanas, sino que se sostengan solos.',
    deliverable: 'Planificador semanal de energía',
  },
]

export const TOMO_INCLUDES: string[] = [
  'Acciones concretas que podés hacer sin preparación previa',
  'Versión imprimible y versión digital de cada tomo',
  'Explicación breve del "por qué funciona" (nada de fe ciega)',
  'Todo adaptado a rutinas laborales de oficina',
]

export type Bonus = {
  number: string
  title: string
  description: string
  price: string
}

export const BONUSES: Bonus[] = [
  {
    number: 'Bono 1',
    title: 'De sedentario a activo, disfrutándolo',
    description:
      'Variantes de movimiento según tu gusto personal, para que dejes de sentirlo una obligación tipo gimnasio.',
    price: '$11.000',
  },
  {
    number: 'Bono 2',
    title: 'Planificador semanal de energía',
    description:
      'Planilla y checklist imprimible para trackear sueño, comidas, movimiento y tu nivel de energía día por día.',
    price: '$11.000',
  },
  {
    number: 'Bono 3',
    title: 'Recetario rápido de energía',
    description:
      'Snacks y comidas listas en minutos, sin preparación compleja ni ingredientes que no tenés en casa.',
    price: '$11.000',
  },
]

export type ValueRowId = 'protocolo' | 'bono-1' | 'bono-2' | 'bono-3'

export const VALUE_ROWS: { id: ValueRowId; label: string; value: string }[] = [
  { id: 'protocolo', label: 'Protocolo Energía Real (4 tomos)', value: '$34.900' },
  { id: 'bono-1', label: 'Bono 1 — De sedentario a activo, disfrutándolo', value: '$11.000' },
  { id: 'bono-2', label: 'Bono 2 — Planificador semanal de energía', value: '$11.000' },
  { id: 'bono-3', label: 'Bono 3 — Recetario rápido de energía', value: '$11.000' },
]

export type BonusDetail = {
  intro: string
  bullets: string[]
  format: string
}

export const BONUS_DETAILS: Record<'bono-1' | 'bono-2' | 'bono-3', BonusDetail> = {
  'bono-1': {
    intro:
      'Para el que odia el gimnasio: en vez de imponerte una rutina, te ayuda a encontrar la forma de moverte que sí vas a sostener porque te gusta.',
    bullets: [
      'Test rápido para descubrir tu perfil de movimiento (social, tranquilo, competitivo o al aire libre)',
      '12 variantes de movimiento con su equivalencia en gasto de energía, para que elijas la que disfrutás',
      'Guía para pasar de 0 a moverte 3 veces por semana sin sentirlo una obligación',
    ],
    format: 'PDF de 18 páginas · Digital e imprimible',
  },
  'bono-2': {
    intro:
      'La planilla que convierte el protocolo en una rutina visible: si no lo trackeás, la semana se te vuelve a ir sin que pase nada.',
    bullets: [
      'Planilla semanal para registrar sueño, comidas, movimiento y nivel de energía del 1 al 10',
      'Checklist diario de 4 acciones mínimas, para las semanas complicadas',
      'Hoja de revisión mensual para ver qué te dio energía y qué te la sacó',
    ],
    format: 'PDF imprimible A4 · Versión para celular incluida',
  },
  'bono-3': {
    intro:
      'Resuelve el momento donde casi todos caen: llegar con hambre, sin tiempo y terminar comiendo cualquier cosa que te tira abajo.',
    bullets: [
      '25 recetas de 10 minutos o menos, con ingredientes de cualquier supermercado',
      'Snacks para la oficina que no generan el bajón de las 4 de la tarde',
      'Lista de compras semanal ya armada, para no improvisar',
    ],
    format: 'PDF de 32 páginas · Digital e imprimible',
  },
}

export const COST_ROWS: { today: string; cost: string }[] = [
  {
    today: 'Llegás al viernes fundido y el finde se te va durmiendo',
    cost: '8 fines de semana perdidos por trimestre',
  },
  {
    today: 'Decís que no a planes, salidas y proyectos por cansancio',
    cost: 'Oportunidades y momentos que no vuelven',
  },
  {
    today: '3 cafés y algo dulce para llegar a la tarde',
    cost: 'Más de $40.000 por año… y el bajón igual llega',
  },
  {
    today: 'Arrancás el gimnasio, pagás la cuota y dejás a la semana',
    cost: 'Cuotas pagadas que no usás + la sensación de fracaso',
  },
  {
    today: 'Cada domingo te prometés que "esta semana sí"',
    cost: 'Otro ciclo de 7 días exactamente igual al anterior',
  },
]
